const Departments = Object.freeze({
    RETAIL: "retail",
    KITCHEN: "kitchen",
    OPERATIONS: "operations",
    AUDIO_VISUAL: "audio visual"
});

export default Departments;